module.exports = __webpack_public_path__ + "charcha-9561ea4ecc1435c01982.jpeg";